import parsePhoneNumber from 'libphonenumber-js'

export function formatPhoneNumber(phone: string) {
  return parsePhoneNumber(phone, 'BR')
}
